import { Typography } from '@mui/material';

import { styles } from './ChunkedJsonUploader.styles';
import { UploadStatus } from './useChunkedUploader';

export const UploadStatusBadge = ({ status }: { status: UploadStatus }) => {
  if (status === 'idle') return null;

  const statusMap = {
    uploading: { text: 'Uploading...', bg: '#e0e0e0', color: '#333' },
    success: { text: 'Completed', bg: '#d0f0da', color: '#2e7d32' },
    error: { text: 'Upload failed', bg: '#fbe9e7', color: '#c62828' },
  } as const;

  const { text, bg, color } = statusMap[status];

  return (
    <Typography variant="caption" sx={styles.statusBadge(bg, color)}>
      {text}
    </Typography>
  );
};
